import {
  IChartSettings,
  IParsedChartDataFunnel,
  IParsedFunnelColumn,
} from '../../../interfaces';
import { IBreakdownOverallStatus } from '../../../../../utils/interfaces';
import { IChartLine } from '../../useChartLines';
import { FunnelModeKey } from '../../../../../utils/apollo/graphqlSchema';
import getFrequencyLines from './getFrequencyLines';
import getTimeToConvertLines from './getTimeToConvertLines';
import getConversionLines from './getConversionLines';
import {
  IAnalysisColorConfig,
  isShouldUseMeasureColor,
} from '../../../utils/analysisColorConfig';
import { UnreachableCaseError } from 'ts-essentials';

const getFunnelVisibleLines = (
  sortedColumns: IParsedFunnelColumn[],
  chartData: IParsedChartDataFunnel,
  chartSettings: IChartSettings,
  isBreakdownOverall: IBreakdownOverallStatus,
  colorConfig: IAnalysisColorConfig,
): IChartLine[] => {
  const shouldUseMeasureColor = isShouldUseMeasureColor(isBreakdownOverall);

  const { mode } = chartData;

  switch (mode) {
    case FunnelModeKey.Frequency: {
      return getFrequencyLines(
        sortedColumns,
        chartData,
        chartSettings,
        colorConfig,
        shouldUseMeasureColor,
      );
    }
    case FunnelModeKey.TimeToConvert: {
      return getTimeToConvertLines(
        sortedColumns,
        chartData,
        chartSettings,
        colorConfig,
        shouldUseMeasureColor,
      );
    }
    case FunnelModeKey.Conversion: {
      return getConversionLines(
        sortedColumns,
        chartData,
        chartSettings,
        colorConfig,
        shouldUseMeasureColor,
      );
    }
    default: {
      throw new UnreachableCaseError(mode);
    }
  }
};

export default getFunnelVisibleLines;
